import React from 'react';
import CustomControl from '../CustomControl/CustomControl';

const TransitFeaturesItem = ({ id, value, checked, onChange, label, children, disabled }) => {
  return (
    <CustomControl
      id={id}
      value={value}
      checked={checked && !disabled}
      onChange={onChange}
      label={label}
      type="checkbox"
      className="custom-control-xs"
      name={id}
      disabled={disabled}
    >
      {children}
    </CustomControl>
  );
};

export default TransitFeaturesItem;
